import { render } from "./BusinessCategories.vue?vue&type=template&id=48394266&scoped=true"
import script from "./BusinessCategories.vue?vue&type=script&lang=js"
export * from "./BusinessCategories.vue?vue&type=script&lang=js"

import "./BusinessCategories.vue?vue&type=style&index=0&id=48394266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48394266"]])

export default __exports__